import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    width: 100%;

    textarea {
        width: 100%;
        height: 6em;
        border: .1em solid white;
        padding: 1em;
        color: ${vars.colorText};
        border-radius: .5em;
        font-size: .9em;
        display: block;

        &::placeholder {
            color: ${vars.colorTextLight};
        }
    }

    &.style-secondary {
        textarea {
            border: .1em solid #F1F1F1;
        }
    }

    &.decorator-left {
        textarea {
            padding-left: 2.5em;
        }
    }
    &.decorator-right {
        textarea {
            padding-right: 2.5em;
        }
    }

	@media all and (max-width: ${vars.mobileL}) {
		textarea {
			font-size: 1.3rem;
		}
	}
`;
